import analytics from 'controllers/analytics';
import { PhotoProcessingQueue } from 'services/upload/photo-processing-queue';
import {
	AppStateModule,
	ConfigModule,
	PhotosModule,
	ProductStateModule,
} from 'store';

const queue = new PhotoProcessingQueue({
	addPhotos: (ids) => ProductStateModule.addPhotos(ids),
	changePhotoId: (ids) => ProductStateModule.changePhotoId(ids),
	clearTimeout: (timeoutId) => window.clearTimeout(timeoutId),
	createPhotoModel: (input, abortSignal) => PhotosModule.createModel({
		data: input,
		requestOptions: {
			signal: abortSignal,
		},
	}),
	getPhotoById: (id) => PhotosModule.getById(id),
	hasSavedPhoto: (id) => ProductStateModule.hasSavedPhoto(id),
	isOnline: () => AppStateModule.online,
	removePhoto: (id) => {
		ProductStateModule.removePhoto(id);
	},
	setTimeout: (handler, timeout) => window.setTimeout(
		handler,
		timeout,
	),
	trackPhotoProcessed: (photoModel, startTime) => {
		analytics.trackEvent(
			'Photo processed',
			{
				fileSizeKb: photoModel.kbyte,
				processTime: (new Date().getTime() - startTime) / 1000,
				source: photoModel.source,
			},
			{
				/*
				 * Since this is a heavily used analytics event, sample it for some labels
				 * to reduce the amount of data sent to analytics providers.
				 */
				moengage: Math.random() <= ConfigModule['analytics.moengage.samplingRate'],
				amplitude: Math.random() <= ConfigModule['analytics.amplitude.samplingRate'],
			},
		);
	},
	updatePhotoModel: (data) => PhotosModule.updateModel(data),
});

export default queue;
